"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DividerRoot = exports.ChildrenWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ChildrenWrapper_1 = __importDefault(require("./ChildrenWrapper"));
exports.ChildrenWrapper = ChildrenWrapper_1.default;
const DividerRoot_1 = __importDefault(require("./DividerRoot"));
exports.DividerRoot = DividerRoot_1.default;
const Divider = ({ children, orientation = 'horizontal', ...rest }, ref) => {
    return ((0, jsx_runtime_1.jsx)(DividerRoot_1.default, { orientation: orientation, as: children ? 'div' : 'hr', ...rest, ref: ref, children: children && ((0, jsx_runtime_1.jsx)(ChildrenWrapper_1.default, { orientation: orientation, children: children })) }));
};
exports.default = (0, react_1.forwardRef)(Divider);
//# sourceMappingURL=index.js.map